import { c as _c } from "react/compiler-runtime";
import { PointerSensor, useSensor, useSensors, type DragCancelEvent, type DragEndEvent, type DragOverEvent, type DragStartEvent } from '@dnd-kit/core';
import type { EagGridStore } from '../store/createEagGridStore';
import type { EagColumnState } from '../types/EagColumnState';
import { useColumnDrag } from './useColumnDrag';
const DRAG_ACTIVATION_DISTANCE = 8;
type UseGridDragAndDropParams = {
  visibleColumnStates: EagColumnState[];
  store: EagGridStore;
  dragManager: ReturnType<typeof useColumnDrag>;
};
type UseGridDragAndDropReturn = {
  sensors: ReturnType<typeof useSensors>;
  handleDragStart: (event: DragStartEvent) => void;
  handleDragOver: (event: DragOverEvent) => void;
  handleDragEnd: (event: DragEndEvent) => void;
  handleDragCancel: (event: DragCancelEvent) => void;
};
export const useGridDragAndDrop = params => {
  const $ = _c(15);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      activationConstraint: {
        distance: DRAG_ACTIVATION_DISTANCE
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const sensors = useSensors(useSensor(PointerSensor, t0));
  let t1;
  if ($[1] !== params) {
    t1 = event => {
      params.store.setActiveDragId(String(event.active.id));
    };
    $[1] = params;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleDragStart = t1;
  let t2;
  if ($[3] !== params) {
    t2 = event_0 => {
      const overId = event_0.over ? String(event_0.over.id) : null;
      if (overId == null) {
        params.store.setDragOver(null, null);
        return;
      }
      const activeIndex = params.visibleColumnStates.findIndex(cs => cs.key === String(event_0.active.id));
      const overIndex = params.visibleColumnStates.findIndex(cs_0 => cs_0.key === overId);
      const side = activeIndex > overIndex ? "left" : "right";
      params.store.setDragOver(overId, side);
    };
    $[3] = params;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleDragOver = t2;
  let t3;
  if ($[5] !== params) {
    t3 = event_1 => {
      params.store.clearDragState();
      params.dragManager.handleDragEnd(event_1);
    };
    $[5] = params;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleDragEnd = t3;
  let t4;
  if ($[7] !== params) {
    t4 = _event => {
      params.store.clearDragState();
    };
    $[7] = params;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const handleDragCancel = t4;
  let t5;
  if ($[9] !== handleDragCancel || $[10] !== handleDragEnd || $[11] !== handleDragOver || $[12] !== handleDragStart || $[13] !== sensors) {
    t5 = {
      sensors,
      handleDragStart,
      handleDragOver,
      handleDragEnd,
      handleDragCancel
    };
    $[9] = handleDragCancel;
    $[10] = handleDragEnd;
    $[11] = handleDragOver;
    $[12] = handleDragStart;
    $[13] = sensors;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};